// import axios from "axios";

export const viewSecuredAttachment = async (documentUrl) => {
  return documentUrl;
  // try {
  //   if (!documentUrl || documentUrl === "https://api.talantahrm.com/") {
  //     return null;
  //   }

  //   const config = {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //     validateStatus: () => true, // allow us to manually check status
  //   };

  //   // Just check if the file is reachable
  //   const response = await axios.get(documentUrl, config);

  //   if (response.status === 200) {
  //     // return the original URL — NO BLOB
  //     return documentUrl;
  //   }

  //   if (response.status === 404) {
  //     console.warn("Attachment not found:", documentUrl);
  //     return null;
  //   }

  //   console.error("Unexpected error:", response.data?.StatusMessage);
  //   return null;
  // } catch (error) {
  //   console.error("Error loading secured attachment:", error);
  //   return null;
  // }
};
